import { React, useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Form from "../../component/utilities/Forms";
import axios from "axios";
import { toast } from "react-toastify";
import Loading from "react-fullscreen-loading";
import { AuthContext } from "../../component/context/AuthContext";
import * as CONST from "../../component/config/Constant";
import "../../assets/css/auth.css";
import { FiLock, FiMail } from "react-icons/fi";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [validate, setValidate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [authUserData, setAuthUserData] = useContext(AuthContext);

  const validateLogin = async () => {
    let isValid = true;
    let validator = Form.validator({
      email: { value: email, isRequired: true, isEmail: true, label: "email" },
      password: { value: password, isRequired: true, minLength: 6, label: "password" },
    });
    if (validator !== null) {
      setValidate({ validate: validator.errors });
      isValid = false;
    }
    return isValid;
  };

  const authenticate = async (e) => {
    e.preventDefault();
    const valid = await validateLogin();
    if (valid) {
      setLoading(true);
      await axios.post(CONST.LOGIN, { email, password })
        .then((response) => {
          setLoading(false);
          if (response?.data?.status === 'error') {
            toast.error(response.data.message);
          } else {
            const d = response.data.data;
            const access_token = d.access_token || "";
            if (access_token) {
              localStorage.setItem("eToken", access_token);
              const UserData = [{
                first_name: d.first_name || "", last_name: d.last_name || "",
                email: d.email || "", status: d.status || "", token: access_token,
                role_id: d.role_id || "", profile_photo_path: d.profile_photo_path || "",
                user_id: d.id || "", department_id: d.department_id || "",
                designation_id: d.designation_id || "", department_name: d.department_name || "",
                is_head: d.is_head || "", is_admin: d.is_admin || "",
                hr_head: d.hr_head || "", permissions: "",
                accepted_terms_and_conditions: d.accepted_terms_and_conditions === "1" || d.accepted_terms_and_conditions === 1 ? 1 : 0,
              }];
              let permissions = response.data.data.permissionsArr[0].permissions;
                if (permissions) {
                localStorage.setItem("ePermissions", btoa(permissions));
                }
              setAuthUserData(UserData);
              toast.success("Login Successfully.. Please wait");
            }
          }
        })
        .catch(() => { setLoading(false); toast.error("Something went wrong. Please try again."); });
    }
  };

  if (authUserData) {
    let isToken = authUserData[0].token ? authUserData[0].token : "";
    if (isToken) {
      const params = new URLSearchParams(location.search);
      const returnTo = params.get("returnTo");
      if (returnTo) navigate(decodeURIComponent(returnTo));
      else navigate("/admin/dashboard");
    }
  }

  return (
    <>
      <Loading loading={loading} background="rgba(0, 0, 0, 0.5)" loaderColor="#fff" />
      <section className="auth-page">
        <div className="auth-page-inner">
          {/* Left - Form (first on mobile) */}
          <div className="auth-form-panel">
            <div className="auth-form-wrapper">
              <div className="auth-form-header">
                <h3 className="auth-form-title">Sign In</h3>
                <p className="auth-form-subtitle">Enter your credentials to continue</p>
              </div>

              <form className="auth-form" method="POST" onSubmit={authenticate} autoComplete="off">
                <div className="auth-input-group">
                  <label className="auth-label"><FiMail size={14} /> Email address</label>
                  <input
                    type="email"
                    className={`form-control auth-input ${validate.validate?.email ? "is-invalid" : ""}`}
                    value={email}
                    placeholder="your@email.com"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {validate.validate?.email && <div className="invalid-feedback d-block">{validate.validate.email[0]}</div>}
                </div>

                <div className="auth-input-group">
                  <label className="auth-label"><FiLock size={14} /> Password</label>
                  <input
                    type="password"
                    className={`form-control auth-input ${validate.validate?.password ? "is-invalid" : ""}`}
                    value={password}
                    placeholder="Your password"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  {validate.validate?.password && <div className="invalid-feedback d-block">{validate.validate.password[0]}</div>}
                </div>

                <div className="auth-options">
                  <label className="auth-checkbox">
                    <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.currentTarget.checked)} />
                    <span>Remember me</span>
                  </label>
                  <Link to="/forget-password" className="auth-forgot-link">Forgot password?</Link>
                </div>

                <button type="submit" className="btn auth-submit-btn">Sign In</button>
              </form>
            </div>
          </div>

          {/* Right - Illustration */}
          <div className="auth-brand-panel">
            <div className="auth-brand-content">
              <h2 className="auth-brand-title">Welcome Back</h2>
              <p className="auth-brand-text">Sign in to access your HR portal, manage leaves, view policies, and stay connected with your team.</p>
              <img
                className="auth-brand-illustration"
                src={process.env.PUBLIC_URL + "/assets/img/login/auth-illustration.svg"}
                alt="Login"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export { Login };
